module.exports = __webpack_public_path__ + "static/img/m_role.9bdfb2c.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/role3/u/m_role.png
// module id = r503
// module chunks = 7